import { createFileRoute, redirect } from '@tanstack/react-router';
import { supabase } from '@/lib/supabase';
import { sessionRole, isKnownRole } from '@/lib/sessionRole';
import { Empty } from '@/components/ui/Empty';

// Explicit landing for an authenticated user whose JWT carries no recognized
// app role (claim missing or unknown). Previously such users were silently
// treated as parents and dropped on the parent dashboard, which RLS then left
// empty — a confusing dead end. This surfaces the real situation instead.
//
// Routing is not a security boundary; RLS still governs data access. A user
// who *does* have a role is bounced to their dashboard so this page can never
// shadow a real account.

export const Route = createFileRoute('/no-role')({
  beforeLoad: async () => {
    const { data } = await supabase.auth.getSession();
    if (!data.session) throw redirect({ to: '/login' });
    const role = sessionRole(data.session);
    if (isKnownRole(role)) {
      throw redirect({ to: '/' });
    }
  },
  component: NoRole,
});

function NoRole() {
  return (
    <main id="main" className="mx-auto max-w-prose px-6 py-16">
      <p className="tracking-[var(--tracking-wide)] text-[var(--color-ink-muted)] text-[var(--text-sm)] uppercase">
        Account setup
      </p>
      <div className="mt-4">
        <Empty
          title="No role assigned"
          description="Your account setup is incomplete — no studio role has been assigned yet. Please contact your studio so they can finish setting up your access."
        />
      </div>
    </main>
  );
}
